import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';

// Services
import LocalizationService from '../../utils/LocalizationService';

// Actions
import { requestStubs, selectAgencyId } from '../../actions/agencyStubs';
import { fetchAgency } from '../../actions/agency';
import { dismissNotification } from '../../actions/reportSummaries';

// Components
import AgencyList from '../Agencies/AgencyList';
import Notification from '../../views/Notification/Notification';

// functional component starts here
const AgencySelector = ({ agencyStubs, agency, error, languageCode, pathRef, id, children }) => {
  const dispatch = useDispatch();
  const { getAccessTokenSilently } = useAuth0();


  console.log('AgencySelector - agencyStubs:', agencyStubs);
console.log('AgencySelector - agencyStubs.items:', agencyStubs.items);
console.log('AgencySelector - agencyStubs.selectedAgencyId:', agencyStubs.selectedAgencyId);
//console.log('AgencySelector - match.params.id:', match.params.id); // match was for RR5
//console.log('AgencySelector - id:', id); // so id doesn't seem to be agency id

  // Handle componentWillMount and componentWillUpdate logic

  useEffect(() => {
  console.log('DEBUG: agencyStubs state', agencyStubs);
}, [agencyStubs]);



  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = await getAccessTokenSilently({
          authorizationParams: {
            audience: process.env.REACT_APP_AUTH0_AUDIENCE,
            scope: 'openid profile email',
          },
        });
        console.log('AgencySelector.js - Access token fetched:', token);

        if (!agencyStubs.selectedAgencyId && agencyStubs.items.length === 0) {
          dispatch(requestStubs(token));
        } else if (agencyStubs.selectedAgencyId && !agency.details._id) {
          dispatch(fetchAgency(agencyStubs.selectedAgencyId, token));
        }
      } catch (err) {
        console.error('AgencySelector.js - Failed to fetch token:', err);
        dispatch(setError(null, 'Token Error', 'Failed to authenticate. Please log in again.'));
      }
    };

    fetchData();
  }, [dispatch, getAccessTokenSilently, agencyStubs.selectedAgencyId, agencyStubs.items, agency.details._id]);

  // Handle componentWillUpdate (selectedAgencyId change)
  useEffect(() => {
    const handleAgencyChange = async () => {
      if (agencyStubs.selectedAgencyId && !agency.details._id) {
        try {
          const token = await getAccessTokenSilently({
            authorizationParams: {
              audience: process.env.REACT_APP_AUTH0_AUDIENCE,
              scope: 'openid profile email',
            },
          });
          console.log('AgencySelector.js - Access token fetched for agency change:', token);
          dispatch(fetchAgency(agencyStubs.selectedAgencyId, token));
        } catch (err) {
          console.error('AgencySelector.js - Failed to fetch token for agency change:', err);
          dispatch(setError(null, 'Token Error', 'Failed to authenticate. Please log in again.'));
        }
      }
    };

    handleAgencyChange();
  }, [dispatch, getAccessTokenSilently, agencyStubs.selectedAgencyId, agency.details._id]);

  // Handle componentWillReceiveProps (select agency from URL or single agency)
  useEffect(() => {
    if (!agencyStubs.selectedAgencyId) {
      //const agencyId = match.params.id || null;
      const agencyId = id || null;
      if (agencyId) {
        dispatch(selectAgencyId(agencyId));
      } else if (agencyStubs.items.length === 1) {
        dispatch(selectAgencyId(agencyStubs.items[0]._id));
      }
    }
  }, [dispatch, id, agencyStubs.selectedAgencyId, agencyStubs.items]);

  const dismiss = () => {
    dispatch(dismissNotification());
  };

  if (!agencyStubs.selectedAgencyId) {
    console.log("agencyStubs.items", agencyStubs.items);
    return (
      <AgencyList
        pathRef={pathRef}
        agencies={agencyStubs.items}
        languageCode={languageCode}
      />
    );
  }

  return (
    <div>
      {error.isActive && (
        <Notification
          text={`Error: ${error.message}`}
          type="danger"
          onDismiss={dismiss}
          show={error.isActive}
        />
      )}
      {children}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    agencyStubs: state.agencyStubs || { items: [], selectedAgencyId: null },
    agency: state.agency || { details: {} },
    languageCode: LocalizationService.getCurrentLanguage(),
    error: state.error || { isActive: false, message: '' },
  };
};

AgencySelector.propTypes = {
  pathRef: PropTypes.string.isRequired,
  agencyStubs: PropTypes.shape({
    items: PropTypes.array,
    selectedAgencyId: PropTypes.string,
  }).isRequired,
  agency: PropTypes.shape({
    details: PropTypes.object,
  }).isRequired,
  error: PropTypes.shape({
    isActive: PropTypes.bool,
    message: PropTypes.string,
  }).isRequired,
  languageCode: PropTypes.string.isRequired,
  id: PropTypes.string,
  children: PropTypes.node,
};

export default connect(mapStateToProps)(AgencySelector);